const apiTimeout = 10000
const imgBaseUrl = 'http://img.laoban100.com'
const mainWebResource = '/OnlineMall/ajax/MobileOnlineMall.ashx'
const mainWebPostData = function (method, params = {}) {
  return {
    'Source': 'PC',
    'Version': '5.0',
    'Method': method,
    'ParamJson': JSON.stringify(params)
  }
}
let apiUrl, mainWeb, iosPayUrl, shopV5Api, shopV5Site, shopTargetSite, wechatBuyShareLink, remoteLogUrl,
  hybirdMobilePay, shopV5CookieDomain
switch (process.env.NODE_ENV) {
  case 'production':
    apiUrl = 'http://webapi.laoban100.com'
    mainWeb = 'http://app-mall.laoban100.com/ApiProxy' // nginx to http://app.laoban100.com
    iosPayUrl = 'http://api.laoban100.com.api/order'
    wechatBuyShareLink = 'http://wechat.i2oo.cn/static' // 微信分享购买地址
    // shopV5
    shopV5Api = 'http://webapi.laoban100.com'
    shopV5Site = 'http://app.laoban100.com'
    shopTargetSite = 'http://app-mall.laoban100.com'
    shopV5CookieDomain = '.laoban100.com'
    // remote log
    remoteLogUrl = 'http://monitor.fe.yuanbei.biz'
    // hybird 移动收款
    hybirdMobilePay = 'http://hybrid.laoban100.com/#/acquire-intro/progress?showNavbar=1'
    break
  case 'testing':
    apiUrl = 'http://pre-webapi4.laoban100.com'
    mainWeb = 'http://mall-test.yuanbei.biz/ApiProxy' // nginx to http://pre-app5.laoban100.com
    // mainWeb = 'http://192.168.20.133:8098' // nginx to http://pre-app5.laoban100.com
    iosPayUrl = 'http://pre-api2.laoban100.com/api/order'
    wechatBuyShareLink = 'http://wechat.i2oo.cn/laoban/static'
    // shopV5
    shopV5Api = 'http://pre-webapi2.laoban100.com'
    shopV5Site = 'http://staging-app.yuanbei.biz' // (作废)
    shopTargetSite = 'http://mall-test.yuanbei.biz'
    shopV5CookieDomain = '.yuanbei.biz'
    // remote log
    remoteLogUrl = 'http://monitor.fe.yuanbei.biz'
    // hybird 移动收款
    hybirdMobilePay = 'http://hybird.fe.yuanbei.biz/#/acquire-intro/progress?showNavbar=1'
    break
  case 'development':
    apiUrl = 'http://pre-webapi4.laoban100.com'
    // mainWeb = `http://localhost:8089`
    mainWeb = 'http://192.168.20.133:8098' // nginx to http://pre-app2.laoban100.com
    wechatBuyShareLink = 'http://wechat.i2oo.cn/laoban/static'
    shopV5Api = ''
    shopV5Site = ''
    iosPayUrl = ''
    // remote log
    remoteLogUrl = 'http://localhost:3000'
    // hybird 移动收款
    hybirdMobilePay = 'http://192.168.20.156:8083/#/acquire-intro/progress?showNavbar=1'
    break
}

export {
  apiUrl,
  mainWeb,
  imgBaseUrl,
  iosPayUrl,
  apiTimeout,
  mainWebResource,
  shopV5Api,
  shopV5Site,
  shopTargetSite,
  wechatBuyShareLink,
  remoteLogUrl,
  mainWebPostData,
  hybirdMobilePay,
  shopV5CookieDomain
}



// WEBPACK FOOTER //
// ./src/config/net.js